import "../Components/ThankYouPage/ThankYou.css";
import Portal from "../Components/ThankYouPage/dashboard-home-2.jpg";
import PortalHealth from "../Components/ThankYouPage/dashboard.health-2.jpg";
import SEO from "../SEO";

function ThankYou() {
  const portalUrl = "https://portal.hyphencreative.co.uk";

  return (
    <div className="thank-you-page">
      <SEO
        title="Thank You | Hyphen Creative"
        description="Thank you for signing up to your website maintenance plan."
      />

      <section id="thank-you-hero">
        <div className="container">
          <div className="thank-you-hero">
            <h1 className="bold">
              You're all set! <span className="light">🎉</span>
            </h1>

            <p className="p-lg">
              Thanks for signing up to your website maintenance plan. We're
              looking forward to keeping your website in tip-top shape.
            </p>
          </div>
        </div>
      </section>

      <section id="thank-you-content">
        <div className="container">
          <div className="thank-you-content">
            <h2>Your client care portal</h2>

            <p>
              Your client care portal is your go-to place for everything
              website-related. Your account has already been set up, so there's
              no need to register again.
            </p>

            <p>Inside, you can:</p>

            <ul>
              <li>
                See a record of the work we've carried out on your website.
              </li>
              <li>Refer other customers and earn money off your next bill.</li>
              <li>
                Submit a support ticket if you spot an issue or need a hand with
                your website.
              </li>
            </ul>

            <p>
              To get started, sign in using your work email address — the one
              you used when signing up to your direct debit.
            </p>

            <p>
              You'll be prompted to update your password the first time you log
              in.
            </p>

            <a href="https://portal.hyphencreative.co.uk">
              <button class="blue-btn">Go to the Client Care Portal</button>
            </a>
          </div>
          <div className="thank-you-portal">
            <a href="https://portal.hyphencreative.co.uk">
              <img
                src={Portal}
                alt="Hyphen Client Care Portal"
                loading="lazy"
                width="100%"
              />
            </a>
            <a href="https://portal.hyphencreative.co.uk">
              <img
                src={PortalHealth}
                alt="Hyphen Client Care Portal"
                loading="lazy"
                width="100%"
              />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ThankYou;
